import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { PromoBanner } from '@agria/theme/src/components/promoBanner/PromoBanner';
import { Stack } from '@agria/theme/src/components/stack/Stack';
import { promoBannersLink } from '../../const/links';

export const SpeciesPromo = () => {
  const images = useStaticQuery(graphql`
    query SpeciesPromoImages {
      bannerOne: file(
        relativePath: { eq: "homepage/qab-homepage-banner-1.jpg" }
      ) {
        ...SpeciesBannerImage
      }
    }

    fragment SpeciesBannerImage on File {
      childImageSharp {
        gatsbyImageData(
          width: 480
          height: 500
          layout: CONSTRAINED
          placeholder: BLURRED
          formats: AUTO
          transformOptions: { fit: COVER, cropFocus: ATTENTION }
          quality: 90
        )
      }
    }
  `);
  return (
    <Stack gap="fluidMedium">
      <PromoBanner
        heading="Lifetime pet insurance you can rely on"
        image={images.bannerOne?.childImageSharp.gatsbyImageData}
        tickListItems={[
          {
            content: 'Up to £20,000 every year towards vet bills',
          },
          {
            content: 'We pay 98% of claims*',
          },
          {
            content: 'Free vet video calls, 24/7',
          },
          {
            content: 'No increase in your premiums when you claim',
          },
          {
            content: `We're the UK's first carbon positive insurer`,
          },
          {
            content:
              'Trusted and recommended by over 50,000 vets, animal rescues and breeders',
          },
        ]}
        imageRight
        footerText="*Based on all Agria Pet Insurance claims received between November 2023 and May 2024"
      />
    </Stack>
  );
};
